<template>

  <div class="ma-detail" :style="{'padding-top' : detail.type != 6 && vcardUrl ? '0' :'0'}">
    <div class="vcard-body" style="position: sticky;" v-if="detail.type !== 6 && vcardUrl&&vcardData.avatar">
      <Vcard
        :posterData="vcardData"
        :posterImg="vcardUrl"
        @open="openModal"
      ></Vcard>
    </div>
    <div class="vcard-body" v-if="detail.type !== 6 && (vcardUrl=='undefined'||vcardUrl==''||vcardUrl==null||!vcardUrl)&&vcardData&&vcardData.avatar" style="padding:0;position: sticky;">
      <VcardContent
        :posterData="vcardData"
        v-if="detail.type !== 6 && (vcardUrl=='undefined'||vcardUrl==''||vcardUrl==null||!vcardUrl)&&vcardData&&vcardData.avatar"
      ></VcardContent>
    </div>
    <div class="ma-title">{{ detail.title }}</div>
    <div class="sub-title flex-center">
      <div></div>
      <div class="flex-center">
        <div class="flex-center" style="margin-right:8px;">
          <img
            src="https://img.esenyun.com/images/20200325/ae085340a78e4e9a828b733304583188.png"
            style="width: 16px; height: 16px; margin-right: 2px;"
          />
          {{ detail.readnum }}
        </div>
        <div class="flex-center" style="margin-right:8px;">
          <img
            src="https://img.esenyun.com/images/20200325/cb636b484f964256958e1b2f47825cf5.png"
            style="width: 16px; height: 16px; margin-right: 2px;"
          />
          {{ detail.sharenum }}
        </div>
        <div class="flex-center" style="margin-right:8px;">
          <img
            src="https://img.esenyun.com/images/20200325/b2b6b40900a74cf08b4c1d4bc10610f6.png"
            style="width: 16px; height: 16px; margin-right: 2px;"
          />
          {{ detail.readpeople }}
        </div>
      </div>
    </div>
    <!-- <div>
      <iframe src="https://mp.weixin.qq.com/s/7kMHupMv9Kl6gywRtPXA_Q"></iframe>
    </div> -->
    <div v-if="!showModal&&detail.content">
      <!-- <div v-html="detail.content" style="padding: 0 16px;"></div> -->
      <AnchoredHeading :html="detail.content" :id="detail.id" :shareId="shareId" :route='$route.query' :vcardData="vcardData" :vcardUrl="vcardUrl"/>
    </div>
    <div v-if="detail.type === 2">
       <lazy-component>
      <img style="width: 100%;" mode="widthFix"  v-lazy="detail.url"/>
      </lazy-component>
    </div>
    <div class="radio-container" v-show="detail.type === 7">
      <div
        class="pic flex-center"
        :style="{ background: `url('${detail.pic}')` }"
      >
        <div
          class="flex-center"
          v-show="playerStatus === 'loading'"
          style="border-radius: 50%;width: 54px;height:54px; background: #1F7DDE;justify-content:center"
        >
          <van-loading color="#fff" />
        </div>
        <img
          class="opt-icon"
          @click="changePlayer('play')"
          v-show="!isPlay && playerStatus !== 'loading'"
          src="https://img.esenyun.com/images/20200709/df1263b3c88d42c18377c5f390915c56.png"
        />
        <img
          class="opt-icon"
          @click="changePlayer('paused')"
          v-show="isPlay && playerStatus !== 'loading'"
          src="https://img.esenyun.com/images/20200709/f3222aa866c74b8eb4138589c2895b0f.png"
        />
      </div>
      <div class="tip">内容由喜马拉雅APP提供</div>
      <div
        class="flex-center"
        style="justify-content: space-between;color:#fff; padding:0 16px"
      >
        <van-count-down
          :time="time"
          :auto-start="false"
          format="mm:ss"
          ref="countDown"
        />
        <div style="width: calc(100% - 42px - 70px);padding: 0 1px;">
          <van-slider v-model="value" @change="onChange" />
        </div>
        <van-count-down
          :time="totalTime"
          :auto-start="false"
          ref="countDownTotal"
          format="mm:ss"
        />
      </div>
    </div>
    <div style="margin: 12px 8px;" v-show="detail.type === 7 && isiOS">
      <div class="ios-tip">
        温馨提示：iOS系统的部分机型可能存在微信播放限制，您可尝试退出微信后再次进入收听
        ~
      </div>
    </div>
    <div style="padding: 0 24px;" v-if="detail.type === 6||detail.type === 8">
      <div class="f-text" v-if="detail.moments_text">{{ detail.moments_text }}</div>
      <van-grid :gutter="10" :column-num="3" :border="false" v-if="detail.moments_pics.length > 1">
        <van-grid-item
          use-slot
          :key="item.material_file"
          v-for="(item,index) in detail.moments_pics"
        >
        <van-image :src="item.material_file" height="90"  @click="preview(item.material_file,index)"/>  
          <!-- <img style="width: 90px; height: 90px;" :src="item.material_file" /> -->
        </van-grid-item>
      </van-grid>
      <div v-else>
         <lazy-component>
           <img
            style="width: 100%"
            mode="widthFix"
            @click="preview(item.material_file)"
            :key="item.material_file"
            v-for="item in detail.moments_pics"
            v-lazy="item.material_file"
          />
          </lazy-component>
         
        </div>
    </div>
    <div class="copywriter" v-if="detail.copywriter">{{detail.copywriter}}</div>
    <!-- 福利活动 -->
    <div
      style="border-top: 8px solid #F7F8FA; padding: 15px 0;"
      v-if="activityList.length>0||cardBagDTOSList.length>0||couponDTOSList.length>0||seckillDTOSList.length>0"
    >
      <div style="text-align:center; padding-top:12px;">
        <img
          src="https://img.esenyun.com/images/20200710/103fe04d9d994e0abc53d9052b2f2d29.png"
          style="width:144px;height:22px;"
        />
      </div>
      <div
        style="margin: 12px 16px 0 16px;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08); border-radius: 5px;"
        v-for="item in activityList"
        :key="item.activityId"
      >
        <ActivityCard :item="item" :vcardUrl="vcardUrl" :envMp="envMp" />
        </div>
        <div  v-if="cardBagDTOSList.length">
           <div
              style="margin: 12px 16px 0 16px;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08); border-radius: 5px;"
              v-for="item in cardBagDTOSList"
              :key="item"
            >
              <cardBag :cardData="item" :shareId="item.shareId" :vcardData="vcardData" :vcardUrl="vcardUrl"/>
            </div>
          </div>
      <div v-if="couponDTOSList.length">
          <div
          style="margin: 12px 16px 0 16px;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08); border-radius: 5px;"
          v-for="item in couponDTOSList"
          :key="item"
        >
          <rollCard :rollDetail="item" :shareId="item.shareId" :vcardData="vcardData" :vcardUrl="vcardUrl"/>
        </div>
      </div>
      <div class="flash-sales" style="margin: 12px 0;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);padding:0 16px" v-if="seckillDTOSList.length">
         <salesCard :list='seckillDTOSList' :vcardData="vcardData" :vcardUrl="vcardUrl"></salesCard>
       </div>
    </div>
    <!-- 相关资讯-->
    <div
      style="text-align:center;border-top: 8px solid #F7F8FA;padding-top: 12px;"
      v-if="recommands && recommands.length"
    >
      <img
        style="width: 144px; height:22px;"
        src="https://img.esenyun.com/images/20200710/f4e7f9154c0b4972929e248c152ddf2d.png"
      />
    </div>
    <!-- 相关资讯-->
    <div
      style="padding: 0 16px;"
      v-for="item in recommands"
      :key="item.id"
      @click="link(item.id)"
    >
      <materialCard :item="item" />
    </div>
    <!-- <div class="footer" v-if="envMp">
      <div class="video-btn btn flex-center"  v-if="pagetype&&pagetype==='homeMaterial'">
        <van-button
          type="primary"
          round
          style="width: 100%;border: none; background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);"
          @click="openShare"
          >转发</van-button
        >
      </div>
      <div class="video-btn btn flex-center" v-else>
        <van-button
          type="primary"
          round
          style="width: 100%;border: none; background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);"
          @click="openShare"
          >一键分享</van-button
        >
      </div> -->
      <!-- <div style="height: 32px;"></div> -->
    <!-- </div> -->
    <!-- <van-image-preview v-model="showPreview" :images="showPreviewUrl" @change="onChangeSuccessImgs" @close="()=>showPreview=false">
        <template v-slot:successImgsIndex>第{{ successImgsIndex }}页</template>
      </van-image-preview> -->
  </div>
</template>

<script>
const { config, XMplayer } = window.xmsdk
import Vue from 'vue'
import env from '../config/env'
import ActivityCard from '../components/activityCard'
import salesCard from '../components/card-slot/salesCard'
import rollCard from '../components/card-slot/roll'
import cardBag from "../components/card-slot/card"
import materialCard from '../components/materialCard'
import AnchoredHeading from '../components/anchoredHeading'
import Vcard from '../components/Vcard'

import VcardContent from '@/components/VcardContent'
// import md5 from '../components/md5'
import moment from 'moment'
import { Toast } from 'vant'
let yssdk = require("ys-sdk")("production");
if(env.env === 'test') {
  yssdk = require("ys-sdk")("test");
}
import { v4 as uuidv4 } from 'uuid'
export default {
  components: {
    Vcard,
    materialCard,
    ActivityCard,
    AnchoredHeading,
    cardBag,
    salesCard,
    rollCard,
    VcardContent
  },
  watch:{
    '$route':function(){
      console.log('route:',this.$route.query);
      const initToast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        overlay: true
      })
      this.init().then(()=>{
        initToast.clear()
      })
    }
  },
  data() {
    return {
      shareId:"",
      moment: moment,
      mType: 'tezan',
      id: '',
      time: null,
      totalTime: null,
      totalSound: null,
      isPlay: false,
      firstPlay: true,
      rate: null,
      value: null,
      player: null,
      playerStatus: '',
      countDown: null,
      recommands: [],
      insertActivityId: '',
      show: false,
      downloadText: '',
      Wxmpfrom: '',
      showShare: false,
      showBg: false,
      vcardUrl: '',
      vcardData: {},
      poster: {
        width: '280px',
        height: '498px',
        views: [
          {
            type: 'img',
            url: '',
            css: {
              width: '280px',
              height: '498px',
              top: '0',
              left: '0',
            },
          },
          {
            type: 'text',
            text: '扫码',
            css: {
              color: '#fff',
              fontSize: '11px',
              lineHeight: '16px',
              bottom: '51px',
              left: '60px',
            },
          },
          {
            type: 'img',
            url:
              'https://img.esenyun.com/images/20200324/21368348090240e09d7da955ef4a5c8f.png',
            css: {
              width: '32px',
              height: '32px',
              borderRadius: '16px',
              bottom: '34px',
              left: '20px',
            },
          },
          {
            type: 'img',
            url:
              'https://img.esenyun.com/images/20200324/21368348090240e09d7da955ef4a5c8f.png',
            css: {
              width: '60px',
              height: '60px',
              bottom: '20px',
              right: '20px',
            },
          },
          {
            type: 'text',
            text: '扫码联系服务专家，了解更多',
            css: {
              color: '#fff',
              fontSize: '8px',
              lineHeight: '12px',
              left: '60px',
              bottom: '37px',
            },
          },
        ],
      },
      showModal: false,
      posterData: {},
      video: '',
      videoId: '',
      Loading: null,
      percent: 0,
      currentIndex: 0,
      img: '',
      successImgs: [],
      friendImgs: [],
      activityList: [],
      cardBagDTOSList:[],
      couponDTOSList:[],
      seckillDTOSList:[],
      downloadTask: null,
      detail: {
        content:null,
        date:'',
        content_platform:null,
        moments_pics:null,
        moments_pics_num:0,
        pic:[],
        type:null,
        sharenum:0,
        title:null,
        platform_content_id:null,
        moments_text:null,
        url:null,
        display_type:null,
        downloadnum:0,
        readpeople:0,
        qrcode_url:null,
        readnum:0,
        font_color:null,
        copywriter:null,
        id:null,
        material_code:null,
      },
      envMp: false,
      sounds: null,
      videoContainer: null,
      isiOS: false,
      tezanSdk: null,
      multiChannelId:"",//渠道id
      showPreview:false,
      showPreviewUrl:null,
      successImgsIndex:0,
      pagetype:''
    }
  },
  async mounted() {
    const u = navigator.userAgent
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    if (window.__wxjs_environment === 'miniprogram') {
      this.pagetype=this.$route.query.pagetype||""
      this.envMp = true
      const script = document.createElement('script');
      script.crossorigin = 'anonymous';
      script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
      document.head.appendChild(script);
    }
    const initToast = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      overlay: true
    })
    this.init().then(()=>{
      initToast.clear()
    })
  },
  destroyed(){
    if (this.mType !== 'ao') {
      this.tezanSdk.event_page_unload()
    }
  },
  methods: {
    preview(file,index = 0) {
      // this.showPreviewUrl=this.detail.moments_pics.map((i) => i.material_file)
      // this.showPreview=true
      // this.$ImagePreview({
      //   images:url, // 当前显示图片的http链接
      //   startPosition:index, // 需要预览的图片http链接列表
      // })
     // let that=this;
       this.successImgsIndex = index;
       this.showPreviewUrl = this.detail.moments_pics.map((i) => i.material_file)
      // this.showPreview=true
      this.$ImagePreview({
        images:this.showPreviewUrl, // 当前显示图片的http链接
        startPosition:index, // 需要预览的图片http链接列表
        closeOnPopstate:true,
        maxZoom: 200, // 最大缩放倍数
      })
    },
    onChangeSuccessImgs(index){
      this.successImgsIndex = index;
    },
    changePlayer(status) {
      if (status === 'play') {
        if (this.playerStatus === 'advertising') return
        this.player.play(this.videoId)
      } else {
        if (this.playerStatus === 'advertising') return
        this.player.pause()
      }
    },
    openShare() {
      let url = `/material/detail?id=${this.id}&from=${this.mType}&multiChannelId=${this.multiChannelId}`
      if(this.pagetype&&this.pagetype==='homeMaterial'){
        url = `/material/detail?id=${this.id}&link=no&from=${this.mType}&vcardUrl=${
            this.vcardUrl
          }&vcardData=${encodeURIComponent(JSON.stringify(this.vcardData))}&multiChannelId=${this.multiChannelId}`

      }else{
        if (this.Wxmpfrom === 'user') {
          url = `/pages/materialDetail?id=${this.id}&link=no&insertActivityId=${
            this.insertActivityId
          }&from=${this.mType}&vcardUrl=${
            this.vcardUrl
          }&vcardData=${encodeURIComponent(JSON.stringify(this.vcardData))}&multiChannelId=${this.multiChannelId}`
        }
      }
      if (this.mType !== 'ao') {
        this.tezanSdk.event_page_share()
      }
      window.wx.miniProgram.navigateTo({
        url: url,
      })
    },
    async finish() {
      console.log('播放完毕')
      this.value = 0
      this.time = this.totalTime
      await this.$share.sleep(1)
      this.$refs.countDown.pause()
    },
    onChange(value) {
      this.player.play()
      this.player.seek(value * this.rate)
      this.time = (this.totalSound - value * this.rate) * 1000
    },
    initVideo() {
      // this.$http.post(
      //   'https://testmoawx.hotwater.com.cn/cfsite/mobile/material/xmly/sign'
      // )
      if (this.firstPlay) {
        this.videoContainer = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '播放器加载中..',
        })
        this.firstPlay = false
      }
      config({
        app_key: 'f5f999fa36fef65454751700e21e734e', // 必传，官方提供的 app_key：b617866c20482d133d5de66fceb37da3 仅供测试，有调用次数限制，上线需替换为自己的 app_key。
        // 官方提供测试使用的 sig_url => https://api.ximalaya.com/openapi-collector-app/jssdk_sig
        // （限制了 app_key 必须是测试账号，并且限制了调用次数，上线需替换为自己的 sig_url）
        sig_url: `https://open-api.tezign.com/open-api/v1/common/xmly/sign`, // 免登录授权，必须传 sig_url，和 get_access_token 互斥
        // sig_url: `${env.materialUrl}cfsite/mobile/material/xmly/sign`, // 免登录授权，必须传 sig_url，和 get_access_token 互斥
        debug: true, // 是否在控制台打印日志
      })
      // 创建音频播放器，播放喜马拉雅声音
      const player = new XMplayer({
        breakpoint: false,
        autoUnlock: false,
        playlist: [this.videoId],
      })
      player.preloadSound(this.videoId)
      this.player = player
      player.on('timeupdate', (position, sound) => {
        this.value = (position / sound.duration) * 100
        this.time =
          sound.duration - position > 0 ? (sound.duration - position) * 1000 : 0
        if (sound.duration - position <= 0) {
          player.stop()
          player.seek(0)

          this.value = 0
        }
      })
      player.on('ready', () => {
        if (this.videoContainer) {
          this.videoContainer.close()
        }
      })
      player.on('loading', (percent) => {
        console.log(percent)
        // if (percent === 1) {
        //   this.sounds.close()
        // }
        // this.sounds.message = `音频加载${parseInt(+percent) * 100}%`
      })
      player.on('change.playState', (playState) => {
        // Toast(`状态：${playState}`)
        this.playerStatus = playState
        if (playState === 'playing') {
          this.isPlay = true
          if (this.sounds) {
            this.sounds.close()
          }
        }
        if (playState === 'advertising') {
          this.isPlay = true
          // this.sounds = Toast.loading({
          //   duration: 0, // 持续展示 toast
          //   forbidClick: true,
          //   message: '等待播放',
          // })
        }
        if (playState === 'paused') {
          this.isPlay = false
        }
        console.log('状态', playState)
      })
      player.on('loaderror', (e) => {
        Toast('加载失败')
        Toast(e.message)
        // this.sounds.close()
        // this.sounds.message = `音频加载${parseInt(+percent) * 100}%`
      })
      player.on('notAllowedError', () => {
        Toast('浏览器限制，需要再次点击播放')
        // this.sounds.close()
        // this.sounds.message = `音频加载${parseInt(+percent) * 100}%`
      })
      player.on('sound.unusable', () => {
        Toast('获取音频信息失败')
      })
      player.on('sound.notExist', () => {
        Toast('查询不到该声音信息')
      })
      player.on('play', async (res) => {
        console.log('播放')
        // this.Loading.close()
        if (!this.time) {
          this.time = res.duration * 1000
          this.totalTime = res.duration * 1000
          this.totalSound = res.duration
          this.rate = res.duration / 100
        }
      })
      player.on('resume', () => {
        console.log('恢复播放')
        this.$refs.countDown.start()
      })
      // // 绑定事件，点击触发开始播放 —— 绝大多数浏览器都禁止了js自动播放音频，需要用户主动交互操作触发播放
      // document.getElementById('play-btn').addEventListener('click', () => {
      //   // 调用播放器的 play() 方法开始播放
      //   // if (this.playerStatus === 'advertising') return
      //   if (this.playerStatus === 'advertising') return
      //   player.play(this.videoId)
      //   // if (this.firstPlay) {
      //   //   this.Loading = Toast.loading({
      //   //     duration: 0, // 持续展示 toast
      //   //     forbidClick: true,
      //   //     message: '等待播放...',
      //   //   })
      //   //   this.firstPlay = false
      //   // }
      // })
      // document.getElementById('pause-btn').addEventListener('click', () => {
      //   // if (this.playerStatus === 'advertising') return
      //   // 调用播放器的 play() 方法开始播放
      //   if (this.playerStatus === 'advertising') return
      //   player.pause()
      //   console.log('暂停2')

      //   this.$refs.countDown.pause()
      //   clearInterval(this.countDown)
      // })
    },
    async init() {
      this.mType = this.$route.query.from || 'tezan'
      this.Wxmpfrom = this.$route.query.Wxmpfrom
      console.log('this.$route.query.from', this.$route.query.from)
      if (!this.$root.$data.store.state.isInitWx) {
        if(window.__wxjs_environment === 'miniprogram'){
          console.log('小程序')
        }else{
          this.$root.$data.store.initwx(true, this.$route.query.code)
        }
      }
      const codes = this.$route.query.codes
      this.multiChannelId = this.$route.query.multiChannelId||""
      if (codes) {
        await this.getCodeParams(decodeURIComponent(codes))
      } else {
        await this.getData(this.$route.query.id)
        const insertActivityId = this.$route.query.insertActivityId
        this.insertActivityId = insertActivityId
        if(this.$route.query.vcardUrl!=''){
           this.vcardUrl =
          this.$route.query.vcardUrl !== 'undefined'
            ? this.$route.query.vcardUrl
            : null

        }
        console.log('this.$route.query.vcardData',this.$route.query.vcardData)
        this.vcardData = this.$route.query && this.$route.query.vcardData ? JSON.parse(this.$route.query.vcardData) : {}
        console.log(this.$route.query.shareId)
        this.shareId=this.$route.query && this.$route.query.shareId ? JSON.parse(this.$route.query.shareId) : {}
        console.log(typeof this.$route.query.shareId)
        console.log(typeof this.shareId)
        console.log('data', this.vcardData)
        this.id = this.$route.query.id
        if (insertActivityId) {
           await this.getActivityList(insertActivityId)
        }
      }
      await this.readyShare()
      // console.log('uuid', uuidv4())
      if(!localStorage.getItem('uuid')) {
        const uuid = uuidv4()
        localStorage.setItem('uuid', uuid)
      }
      console.log('uuid',localStorage.getItem('uuid'))
      console.log('env',env.env)
      console.log('mType',this.mType)
      if (this.mType !== 'ao') {
        this.tezanSdk = new yssdk.Log({
          unionId: null,
          userId: localStorage.getItem('uuid'),
          openId: null,
          character: 'customer',
          clientHeight: window.screen.height,
          contentId: this.$route.query.id ? Number(this.$route.query.id) : null,
          sellerId: this.vcardData&&this.vcardData.userId? this.vcardData.userId:this.vcardData&&this.vcardData.mobile?this.vcardData.mobile:null,
          sellerName: this.vcardData&&this.vcardData.name?this.vcardData.name:null,
          isShared:true,
          sourceFrom:this.multiChannelId
          // logType: '',
        })
        this.tezanSdk.event_page_pv()
        this.tezanSdk.event_page_access_time()
      }
      return new Promise((reslove)=>{
        reslove(true)
      });
    },
    openModal(e) {
      this.showModal = e
    },
    async link(id) {
      if (this.envMp) {
        if (this.Wxmpfrom === 'user') {
          let url = `/pages/materialDetail?id=${id}&vcardUrl=${
            this.vcardUrl
          }&from=${this.mType}&vcardData=${encodeURIComponent(
            JSON.stringify(this.vcardData)
          )}&shareId=${encodeURIComponent(JSON.stringify(this.shareId))}&multiChannelId=${this.multiChannelId}`
          window.wx.miniProgram.navigateTo({
            url: url,
          })
        } else {
          if (this.detail.type === 7) {
            // this.$router.push(
            //   `material?id=${id}&vcardUrl=${this.vcardUrl}&from=${
            //     this.mType
            //   }&vcardData=${encodeURIComponent(JSON.stringify(this.vcardData))}&shareId=${encodeURIComponent(JSON.stringify(this.shareId))}`
            // )
            // location.reload()
            this.linkToNative(id);
          } else {
            window.wx.miniProgram.navigateTo({
              url: `/material/detail?id=${id}&from=${this.mType}&multiChannelId=${this.multiChannelId}`,
            })
          }
        }
      } else {
        // this.$router.push(`material?id=${id}&from=${this.mType||''}&shareId=${encodeURIComponent(JSON.stringify(this.shareId))}`)
        // location.reload()
        this.linkToNative(id);
      }
    },
    async linkToNative(id){
      let redirectUri='material'
      let url=`id=${id}&vcardUrl=${this.vcardUrl||''}&from=${this.mType||''}&shareId=${encodeURIComponent(JSON.stringify(this.shareId))}&vcardData=${encodeURIComponent(JSON.stringify(this.vcardData))}&multiChannelId=${this.multiChannelId||''}` 
      Vue.ss.set('pageUrl',url)
      Vue.ss.set('redirectUri',redirectUri)
      console.log('redirectUri',Vue.ss.get('redirectUri'))
      console.log('pageUrl',Vue.ss.get('pageUrl'))
      if(this.$store.getters.isWeiXin){
        // 业务跳转，清除记录
        Vue.ls.remove('AO_APP_ACTIVITY_URL_NUM_H5')

        const openId = await this.$store.dispatch("wxLogin/wxLogin");
        console.log('wxLogin:',openId); 
        // 如果已经授权则直接跳转
        if(openId){
          this.$router.push(`${redirectUri}?${url}`);
        }
      }else{
        this.$Dialog.alert({message: '请在微信客户端打开链接',}).then(() => {})
      }
    },
    readyShare() {
      //  var ua= window.navigator.userAgent.toLowerCase();
      window.wx.ready(async () => {
        // alert('成功')
        // const shareUrl = encodeURIComponent(`https://dev-wxcp.nextxx.cn/campaign/#/?id=${this.id}`)
        const shareUrl = `${location.origin}${location.pathname}#/material?id=${
          this.id
        }&insertActivityId=${this.insertActivityId}&vcardUrl=${
          this.vcardUrl
        }&from=${this.mType}&vcardData=${encodeURIComponent(
          JSON.stringify(this.vcardData)
        )}&shareId=${encodeURIComponent(JSON.stringify(this.shareId))}&multiChannelId=${this.multiChannelId}`
        //需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareAppMessage({
          title: this.detail.title, // 分享标题
          desc: this.detail.description||"「斯」家好生活，AO有一套！ - A.O.史密斯", // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detail.pic[0], // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        window.wx.onMenuShareTimeline({
          title: this.detail.title, // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detail.pic[0], // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        // if((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')){
        //   window.wx.onMenuShareWechat({
        //     title: this.detail.title, // 分享标题
        //     desc: this.detail.description||"「斯」家好生活，AO有一套！ - A.O.史密斯", // 分享描述
        //     link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //     imgUrl: this.detail.pic[0], // 分享图标
        //     success: () => {
        //       // 用户点击了分享后执行的回调函数
        //     },
        //   })
        // }
        
      })
    },
    getActivityList(id) {
      this.$http
        .get(
          `aocampaign/openapi/activity/contentInsertActivityList?insertActivityId=${id}`
        )
        .then((res) => {
          if(!this.shareId){
            return
          }
          let shareIdObject= JSON.parse(this.shareId)
          console.log('this.shareId',shareIdObject)
           if(!shareIdObject.shareIds){
            return
          }
          let shareIds=shareIdObject.shareIds
          let shareIdList=[]
          if(shareIds){
            shareIdList=JSON.parse(shareIds)
          }
          console.log('shareIdList',shareIdList)
          if(shareIdList.length>0){
            shareIdList.forEach((sl)=>{
              if(sl.type==='ACTIVITY'){
                if(res.data.activityDTOS&&res.data.activityDTOS.length>0){
                  res.data.activityDTOS.forEach(x=>{
                    if(x.activityId===sl.activityId){
                        x.shareId=sl.shareId
                    }
                  })
                  this.activityList = res.data.activityDTOS||[]
                }
              }
              if(sl.type==='RIGHTS_COUPON'){
                   if(res.data&&res.data.couponDTOS&&res.data.couponDTOS.length>0){
                        let datail=res.data.couponDTOS
                        if(datail.length>0){
                          datail.forEach((x)=>{
                             if(x.couponId===sl.activityId){
                                  x.shareId=sl.shareId
                                  if(x.ladders&&x.ladders.length>0){
                                      let xx=0
                                      let dd=0
                                      if(x.ladders.length>0){
                                        for(let j=0;j<x.ladders.length;j++){
                                          if(x.ladders[0]&&x.ladders[0].couponAmount&&x.ladders[0].couponAmount>0){
                                            xx=x.ladders[0].couponAmount
                                            if(j>0){
                                              dd=x.ladders[j].couponAmount
                                            }
                                          }
                                        }
                                      }
                                      x.xx=xx
                                      x.dd=dd
                                      x.discountType='LADDER'
                                  }
                                  if(x.expiredDate){
                                      let expiredTime = this.moment(x.expiredDate).format("YYYY-MM-DD")
                                      x.expiredDate=expiredTime
                                  }
                              }
                          })
                        }
                        this.couponDTOSList=datail
                  }

              }
              if(sl.type==='RIGHTS_CARD_BAG'){
                  if(res.data.cardBagDTOS&&res.data.cardBagDTOS.length>0){
                    let datail = res.data.cardBagDTOS;
                    for(let x=0;x<datail.length;x++){
                       if(x.packageId===sl.activityId){
                          let expiredTime =x.expiredDate?this.moment(x.expiredDate).format("YYYY-MM-DD"):''
                          x.expiredTime=expiredTime
                          x.shareId=sl.shareId
                       }
                    }
                    this.cardBagDTOSList=datail
                  }
               }
               if(sl.type==='RIGHTS_SPIKE'){
                  if(res.data.seckillDTOS&&res.data.seckillDTOS.length>0){
                    res.data.seckillDTOS.forEach(x=>{
                      if(x.seckillId===sl.activityId){
                          x.shareId=sl.shareId
                      }
                    })
                    this.seckillDTOSList = res.data.seckillDTOS||[]
                  }
               }
            })
          }
   
        })
    },
    getAPI(id) {
      if (this.mType === 'ao') {
        const formData = new FormData()
        formData.append('materialId', id)
        return this.$http(env.materialUrl + 'cfsite/material/detail', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          // mode: 'cors',
          data: formData,
        })
      } else {
        return this.$http(
          `aocampaign/openapi/tezign/getMaterialDetail?materialId=${id}&channelCode=${this.multiChannelId}`
        )
      }
    },
    getData(id) {
      return new Promise((s) => {
        this.getAPI(id).then(async (res) => {
          if (res.data.error) {
            this.$Toast(res.data.message)
          }
          s()
          this.detail = {}
          let data = {}
          if (this.mType !== 'ao') {
            data = res.data.result
          } else {
            data = res.data
          }
          this.detail = data.model
          document.title =data.model.title
          console.log('detail', this.detail)
          let recommands = data.recommands
          if (recommands && recommands.length) {
            recommands.forEach((item) => {
              item.type = 1
              item.display_type = 1
              item.recommands = true
            })
            this.recommands = recommands
          } else {
            this.recommands = []
          }
          if (this.detail.type === 7) {
            this.videoId = +this.detail.platform_content_id
            this.initVideo()
            return
          }
          if(this.detail && this.detail.content) {
            this.detail.content = this.detail.content.replace(
              'http://material.aosmith',
              'https://material.aosmith'
            )
            // eslint-disable-next-line
            this.detail.content = this.detail.content.replace(
              // eslint-disable-next-line
              /\<img/gi,
              '<img class="rich-img" '
            )
            this.detail.content = this.detail.content.replace(
              // eslint-disable-next-line
              /\<section/gi,
              '<section class="rich-section" '
            )
          }
          if(this.detail.url && this.detail.type == 3) {
            console.log('url', this.detail.url)
            this.detail.content = `<video style="width: 100%;" poster="${this.detail.pic}" src="${this.detail.url}" controls></video>`
          }
          // const poster = this.detail.pic
          // this.detail.content = this.detail.content.replace(
          //   /<object\b[^<>]*>.*?<\/object>/gi,
          //   function(match) {
          //     match = match.replace(
          //       'http://material.aosmith',
          //       'https://material.aosmith'
          //     )
          //     const start = match.indexOf('https://material.aosmith')
          //     const upEnd = match.indexOf('MP4')
          //     const end = match.toLocaleLowerCase().indexOf('mp4')
          //     console.log(3333, poster)
          //     const videoUrl =
          //       match.slice(start, end) + (upEnd !== -1 ? 'MP4' : 'mp4')
          //     return `<video style="width: 100%;" src="${videoUrl}" poster="${poster}" controls="controls"></video>`
          //   }
          // )
          // eslint-disable-next-line
          if(this.detail && this.detail.content) {
            this.detail.content = this.detail.content.replace(
              // eslint-disable-next-line
              /\<h1/gi,
              '<h1 style="line-height: 45px;" '
            )
            // eslint-disable-next-line
            this.detail.content = this.detail.content.replace(
              // eslint-disable-next-line
              /\<h2/gi,
              '<h2 style="line-height: 35px;" '
            )
          }
        })
      })
      // this.$http.post(
      //   'https://moawx.hotwater.com.cn/cfsite/material/detail',
      //   {
      //     materialId: '074065ab14424463b547b88aa98f8271',
      //   },
      //   {
      //     header: {
      //       'Content-Type': 'application/x-www-form-urlencoded',
      //     },
      //   }
      // )
    },
    // 获取存储参数的code
    getCodeParams(codes) {
      return new Promise((s) => {
        this.$http
          .get(
            'aocampaign/openapi/common/parms/restore?key=' +
              encodeURIComponent(codes)
          )
          .then(async (res) => {
            console.log('%c 解密', 'color:orange', res.data)
            if (res.data.indexOf('&{') !== -1) {
              res.data = res.data.replace(/%/g, '%25')
              const data = res.data.split('&{')
              this.vcardUrl = data[0] !== 'null' ? data[0] : ''
              console.log(data[1])
              this.detail = JSON.parse(decodeURIComponent('{' + data[1])).model
            } else {
              const data = res.data.split('&')
              this.vcardUrl = data[0] !== 'null' ? data[0] : ''
              this.getData(data[1])
              this.insertActivityId = ''
              this.id = data[1]
            }
            console.log(this.detail)
            // eslint-disable-next-line

            // if (this.detail.type === 3) {
            //   const start = this.detail.content.indexOf(
            //     'https://material.aosmith'
            //   )
            //   const end = this.detail.content.indexOf('mp4')
            //   this.video = this.detail.content.slice(start, end) + 'mp4'
            // }
            console.log(this.detail.content)
            s()
          })
      })
    },
    
  },
}
</script>

<style lang="less">
.van-slider__button {
  width: 10px !important;
  height: 10px !important;
  background: #fff;
}
.van-slider {
  background: #9ba2ab;
}
.van-slider__bar {
  height: 4px;
  background: #fff;
}
.van-count-down {
  color: #fff;
}
p {
  margin: 0;
}
body {
  background: #fff;
}
.ios-tip {
  padding: 4px 8px;
  background: #f7f8fa;
  border-radius: 3px;
  color: #4a4a4a;
  font-size: 12px;
  line-height: 20px;
}
.radio-container {
  height: 350px;
  background: #686e77;
  backdrop-filter: blur(4px);
  padding-top: 24px;
  .pic {
    margin: auto;
    width: 250px;
    height: 250px;
    position: relative;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    justify-content: center;
    box-shadow: 2px 2px 20px #35445b;
    border-radius: 5px;
    .opt-icon {
      width: 54px;
      height: 54px;
    }
  }
  .tip {
    color: #fff;
    text-align: center;
    margin-top: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
  }
}
.ma-detail {
  background: #fff;
  padding-bottom: 120px;
  padding-top: 64px;
  --popup-round-border-radius: 8px;
  --grid-item-content-padding: 0;
  img {
    display: inline-block;
  }
  /deep/.van-grid {
    padding: 0 !important;
    /deep/.van-grid-item__content {
      padding: 0 !important;
    }
  }
  .f-text {
    font-size: 16px;
    line-height: 28px;
    color: #323233;
    margin-bottom: 24px;
  }
  .video-btn {
    justify-content: space-between;
  }
  .progress {
    width: 300px;
    padding: 32px;
  }
  .video {
    width: 100%;
    height: 210px;
  }
  .rich-img {
    max-width: 100% !important;
    height: auto !important;
  }
  .rich-section {
    max-width: 100% !important;
  }
  .ma-title {
    padding: 0 16px;
    padding-top: 24px;
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
  }
  .sub-title {
    padding: 0 16px;
    padding-top: 12px;
    padding-bottom: 24px;
    font-size: 14px;
    line-height: 24px;
    color: #969799;
    justify-content: space-between;
  }
  .vcard-body {
    width: 100%;
    position: sticky;
    z-index: 99;
    top: 0;
    background: #fff;
    height: 64px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    padding: 0 16px;
  }
}
.copywriter{
  padding: 16px;
  font-size: 14px;
  color: #323233;
}
</style>
